<div class="qc_rule">
    <div class="main_content">
        <app-breadcrumb></app-breadcrumb>
        <div class="page_main_sec">
            <mat-tab-group [(selectedIndex)]="grpTabIndex">
                <mat-tab label="QC View">
                    <div class="row">
                        <div class="col-lg-12">

                            <app-basic-gridview *ngIf="lstQCData.length > 0" class="setgrid" [lstData]="lstQCData"
                                [gridTitle]="'QC Logic'" [showExcelDownloadOption]="false" [showSearchOption]="true"
                                [showRecordsPerPageOption]="true" [hyperlinkCols]="['edit','delete']"
                                [columnsToHide]="qcViewColumnHide" [showPagination]="true"
                                (cellClickEvent)="cellClickEventQC($event)"></app-basic-gridview>
                        </div>
                    </div>
                </mat-tab>
                <mat-tab label="Add Rules">
                    <div class="form-container">
                        <div class="row selection-sec">
                            <div class="row form-control-sec">

                                <div class="row">

                                    <div class="col-lg-3">
                                        <mat-form-field appearance="legacy" [style.width.%]="100">
                                            <mat-label>Work Item Type
                                                <span class="field-mandatory">*</span>
                                            </mat-label>
                                            <mat-select [(ngModel)]="selectedDocumentType"
                                                (selectionChange)="onSelectDocumentType($event.value,0,0)">
                                                <mat-option [value]="doc.docTypeId" *ngFor="let doc of lstDocumentType">
                                                    {{doc.docTypeName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-3">
                                        <mat-form-field appearance="legacy" [style.width.%]="100">
                                            <mat-label>QC Execution <span class="field-mandatory">*</span></mat-label>
                                            <mat-select [(ngModel)]="selectedQCExecution">
                                                <mat-option [value]="qc.qcExecutionId"
                                                    *ngFor="let qc of lstQCExecution">
                                                    {{qc.qcExecutionName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-3">
                                        <mat-form-field appearance="legacy" [style.width.%]="100">
                                            <mat-label>From Process </mat-label>
                                            <mat-select [(ngModel)]="selectedFromProcess"
                                                (selectionChange)="onSelectFromProcess($event.value,0)">
                                                <mat-option [value]="process.fromProcessId"
                                                    *ngFor="let process of lstFromProcess">
                                                    {{process.fromProcessName}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                    <div class="col-lg-3">
                                        <mat-form-field appearance="legacy" [style.width.%]="100">
                                            <mat-label>To Process</mat-label>
                                            <mat-select [(ngModel)]="selectedToProcess">
                                                <mat-option [value]="process.toProcessId"
                                                    *ngFor="let process of lstToProcess">
                                                    {{process.toProcessname}}
                                                </mat-option>
                                            </mat-select>
                                        </mat-form-field>
                                    </div>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-3">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>QC Process <span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedQCProcess">
                                            <mat-option [value]="qc.qcProcessId" *ngFor="let qc of lstQCProcess">
                                                {{qc.qcProcessName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field [style.width.%]="100">
                                        <mat-label>Rule Name <span class="field-mandatory">*</span></mat-label>
                                        <input matInput id="txtRuleName" [(ngModel)]="ruleName" placeholder="Rule Name">

                                    </mat-form-field>
                                </div>
                                <div class="col-lg-3">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Status <span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedStatus">
                                            <mat-option [value]="status.statusId" *ngFor="let status of lstStatus">
                                                {{status.statusName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                            </div>

                        </div>

                        <div class="row selection-sec">
                            <div class="textwrap">CONDITION</div>
                            <div class="row">
                                <div class="col-lg-2">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Column<span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedColumn"
                                            (selectionChange)="onSelectColumn($event.value,'0','0','')">
                                            <mat-option [value]="col.columnId" *ngFor="let col of lstColumnName">
                                                {{col.columnName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Comparison Type<span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedCompType">
                                            <mat-option [value]="cmpType.compTypeId"
                                                *ngFor="let cmpType of lstCompType">
                                                {{cmpType.compTypeName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Operator<span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedOperator">
                                            <mat-option [value]="operator.operatorId"
                                                *ngFor="let operator of lstOperator">
                                                {{operator.operatorName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2" *ngIf="valDropdown;else other_content">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Value<span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedValue">
                                            <mat-option [value]="lst.valueId" *ngFor="let lst of lstValue">
                                                {{lst.valueName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <ng-template #other_content>
                                    <div class="col-lg-2">
                                        <mat-form-field [style.width.%]="100" #other_content>
                                            <mat-label>Value<span class="field-mandatory">*</span></mat-label>
                                            <input matInput id="txtValue" [(ngModel)]="strValue" placeholder="Value">
                                        </mat-form-field>
                                    </div>
                                </ng-template>

                                <div class="col-lg-2">
                                    <mat-form-field appearance="legacy" [style.width.%]="100">
                                        <mat-label>Connector<span class="field-mandatory">*</span></mat-label>
                                        <mat-select [(ngModel)]="selectedConnector">
                                            <mat-option [value]="connector.connectorId"
                                                *ngFor="let connector of lstConnector">
                                                {{connector.connectorName}}
                                            </mat-option>
                                        </mat-select>
                                    </mat-form-field>
                                </div>
                                <div class="col-lg-2 text-center">
                                    <input type="button" id="txtAdd" [(ngModel)]="strAdd"
                                        class="btn smallButton btnFormat" [value]="" (click)="onAddClick()">

                                    <!-- <input type="button" id="txtClear" class="btn resetButton btnFormat" value="CLEAR"
                                        (click)="onClearClick()"> -->
                                </div>
                            </div>
                            <div class="row">
                                <div class="col-lg-12">
                                    <app-basic-gridview *ngIf="lstConditionData.length > 0" [lstData]="lstConditionData"
                                        [gridTitle]="''" [showExcelDownloadOption]="false" [showSearchOption]="false"
                                        [showRecordsPerPageOption]="false" [showPagination]="false"
                                        [columnsToHide]="qcRuleColumnHide" [hyperlinkCols]="['edit','delete']"
                                        (cellClickEvent)="cellClickEvent($event)"></app-basic-gridview>
                                </div>

                            </div>
                            <div class="row">
                                <div class="col-lg-12 text-center">
                                    <input type="button" id="txtSave" [(ngModel)]="strSubmit"
                                        class="btncss me-2 btn_primary" value="" (click)="onSaveClick()">
                                    <input type="button" id="txtReset" class="btncss me-2 btn_secondary" value="RESET"
                                        (click)="onResetClick()">
                                </div>
                            </div>
                        </div>
                    </div>

                </mat-tab>
            </mat-tab-group>


        </div>
    </div>
</div>